import newRouters from "@/new/router";
import { MainRouterHook } from "@/new/auth/main.router-hook";
import get_title from "@/router/module/get_title";

import Catalog from "./catalog";
import Categories from "./Categories";
import History from "./History";
import Main from "./Main";

export default {
  path: "/",
  name: "Main",
  redirect: {
    path: "/content",
  },
  meta: {
    title: get_title(process.env.VUE_APP_TITLE),
    forVisitors: true,
    requiresAuth: true
  },
  component: () => import("@/views/Content"),
  children: [...Catalog, Main, Categories, History, ...newRouters],
  beforeEnter: MainRouterHook,
};
